import React from 'react';
import { InputAdornment, Typography } from '@mui/material';
import type { InputAdornmentOwnProps } from '@mui/material';

type AdornmentProps = InputAdornmentOwnProps & {
    label: string;
};

export default ({ label, ...props }: AdornmentProps) => {
    return (
        <InputAdornment {...props}>
            <Typography variant="adornment">{label}</Typography>
        </InputAdornment>
    );
};
